import { Scene } from 'three'
import BirdCamera from './world/BirdCamera'
import Constants from './lib/Constants'
import Cursor from './utils/Cursor'
import Database from './lib/Database'
import Debug from './utils/Debug'
import LoaderAnimations from './lib/LoaderAnimations'
import Renderers from './lib/Renderers'
import Resources from './utils/Resources'
import Sizes from './utils/Sizes'
import Time from './utils/Time'
import UI from './lib/UI'
import World from './world/World'
import Translator from './utils/Translator'

export default class App
{
    async init()
    {
        Constants.VARS.isMobile = this.mobileCheck()
        Constants.VARS.mode = 'w'
        Constants.VARS.firstInteraction = false
        Constants.VARS.hasAutoclicked = false
        Constants.VARS.isActive = false

        this.translator = new Translator()

        this.loaderAnimations = new LoaderAnimations()

        this.debug = new Debug()
        this.time = new Time({ debug: this.debug })
        this.sizes = new Sizes()

        this.loaderAnimations.update(0.25)
        this.database = await Database.initDatabase(this.translator)

        this.loaderAnimations.update(0.50)



        this.startTime = performance.now()
        this.resources = await Resources.init()

        // Loading Screen
        this.resources.on('progress', (e) =>
        {
            this.loaderAnimations.update((e * 0.5) + 0.5)
        })

        this.resources.on('ready', () =>
        {
            this.elapsed = ((performance.now() - this.startTime) / 1000).toPrecision(4)

            this.setUI()
            this.setCamera()
            this.setRenderer()
            this.setWorld()
            this.setDebug()
            this.activateWebsite()
        })
    }

    setUI()
    {
        this.ui = new UI({ database: this.database, sizes: this.sizes, time: this.time })
        this.cursor = new Cursor({ sizes: this.sizes, ui: this.ui })
    }

    activateWebsite()
    {
        if(Constants.VARS.isActive) return
        Constants.VARS.isActive = true
        this.ui.createHandlers()
        this.ui.createWineButtons()
        this.renderers.activateRenderer()
        this.loaderAnimations.end()
        this.cursor.forceUpdate()
        this.ui.setAutoclick()
        this.ui.setArrowsVisibility(0)
    }

    setCamera()
    {
        this.scene = new Scene()
        this.camOptions =
        {
            time: this.time,
            sizes: this.sizes,
            cursor: this.cursor
        }
        this.camera = new BirdCamera(this.camOptions)
        this.scene.add(this.camera.container)

        this.ui.camera = this.camera
    }

    setRenderer()
    {
        this.renderers = new Renderers({ time: this.time, sizes: this.sizes, scene: this.scene, camera: this.camera })
        this.camera.setControls(this.renderers.renderer)
    }

    setWorld()
    {
        this.world = new World({
            database: this.database,
            ui: this.ui,
            debug: this.debug,
            time: this.time,
            cursor: this.cursor,
            resources: this.resources,
            camera: this.camera
        })
        this.scene.add(this.world.container)
    }

    setDebug()
    {
        if(this.debug.enableLogs)
        {
            window.addEventListener('keydown', (e) =>
            {
                switch(e.code)
                {
                    case 'KeyC':
                        console.log("CAMERA POSITION: ", this.camera.instance.position)
                        console.log("TARGET POSITION: ", this.camera.controls.target)
                        break
                    case 'KeyR':
                        console.log("RENDER INFO: ", this.renderers.renderer.info.render)
                        break
                    case 'KeyO':
                        console.log("OBJECTS: ", this.scene.children)
                        break
                }
            })
        }
    }

    mobileCheck()
    {
        if (navigator.userAgentData)
        {
            return navigator.userAgentData.mobile
        }
        else
        {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
    }

    destructor()
    {
        this.time.off('tick')
        this.sizes.off('resize')
        this.camera.controls.dispose()
        this.renderer.dispose()
    }
}